import type { HelpLocale } from './help';

/**
 * The presence strings: who is here, and what they are doing.
 *
 * Lifted out of infostation.html by evaluating the original literal — the same method the help
 * and chat text moved by, for the same reason. Falls back to English for an unknown locale.
 */
export const PRESENCE_I18N = {
  "you": {
    "en": "You",
    "fr": "Vous",
    "de": "Sie"
  },
  "viewing": {
    "en": "viewing",
    "fr": "consulte",
    "de": "sieht"
  },
  "editing": {
    "en": "editing",
    "fr": "modifie",
    "de": "bearbeitet"
  },
  "onmap": {
    "en": "on the map",
    "fr": "sur la carte",
    "de": "auf der Karte"
  },
  "adoc": {
    "en": "a document",
    "fr": "un document",
    "de": "ein Dokument"
  },
  "anode": {
    "en": "a node",
    "fr": "un nœud",
    "de": "einen Knoten"
  }
} as const;

export type PresenceKey = keyof typeof PRESENCE_I18N;

export function presenceText(key: PresenceKey, locale: string): string {
  const s = PRESENCE_I18N[key] as Record<string, string> | undefined;
  return (s && (s[locale as HelpLocale] ?? s.en)) || '';
}
